import React from 'react';
export const HowItWorksSection = () => {
  const steps = [{
    number: '01',
    title: 'Post & Attract',
    description: 'Create compelling job listings optimized for sales roles and distribute them to the right channels to attract qualified candidates.',
    image: 'https://images.unsplash.com/photo-1512486130939-2c4f79935e4f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=600&q=80'
  }, {
    number: '02',
    title: 'Screen & Assess',
    description: 'Our AI-powered screening tools filter candidates based on sales-specific criteria and assess their aptitude for success.',
    image: 'https://images.unsplash.com/photo-1553877522-43269d4ea984?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=600&q=80'
  }, {
    number: '03',
    title: 'Interview & Evaluate',
    description: 'Use our structured interview guides and collaborative tools to evaluate candidates consistently across your team.',
    image: 'https://images.unsplash.com/photo-1560439514-4e9645039924?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=600&q=80'
  }, {
    number: '04',
    title: 'Select & Hire',
    description: 'Make data-driven hiring decisions and seamlessly onboard your new sales talent with our integrated tools.',
    image: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=600&q=80'
  }];
  return <section id="how-it-works" className="py-16 md:py-24 bg-gray-50" data-id="element-171">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-172">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-173">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-174">
            How ApplicantPass Works
          </h2>
          <p className="text-xl text-gray-600" data-id="element-175">
            Our streamlined process helps you find and hire the best sales
            talent efficiently
          </p>
        </div>
        <div className="relative" data-id="element-176">
          {/* Connection line */}
          <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-1 bg-blue-200 transform -translate-x-1/2" data-id="element-177"></div>
          <div className="space-y-24 md:space-y-32" data-id="element-178">
            {steps.map((step, index) => <div key={index} className="relative md:grid md:grid-cols-2 md:gap-8 items-center" data-id="element-179">
                {/* Circle connector */}
                <div className="hidden md:block absolute left-1/2 top-1/2 w-5 h-5 rounded-full bg-blue-500 transform -translate-x-1/2 -translate-y-1/2" data-id="element-180"></div>
                <div className={`mb-8 md:mb-0 ${index % 2 === 0 ? 'md:text-right md:pr-16' : 'md:order-2 md:text-left md:pl-16'}`} data-id="element-181">
                  <span className="inline-block text-3xl font-bold text-blue-600 mb-2" data-id="element-182">
                    {step.number}
                  </span>
                  <h3 className="text-2xl font-semibold text-gray-900 mb-2" data-id="element-183">
                    {step.title}
                  </h3>
                  <p className="text-gray-600" data-id="element-184">{step.description}</p>
                </div>
                <div className={`${index % 2 === 0 ? 'md:order-2 md:pl-16' : 'md:pr-16'}`} data-id="element-185">
                  <div className="relative" data-id="element-186">
                    <div className="absolute inset-0 bg-blue-200 rounded-lg transform translate-x-2 translate-y-2" data-id="element-187"></div>
                    <div className="relative bg-white p-3 rounded-lg shadow-lg" data-id="element-188">
                      <img src={step.image} alt={`${step.title} process visualization`} className="w-full h-64 object-cover rounded-md" data-id="element-189" />
                    </div>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
};